import { z } from "zod";
import { ForgeProject, ForgeProjectContext } from "@supernova-studio/model";
import { DTOForgeProjectMember } from "./project-member";

export const DTOForgeProject = ForgeProject.omit({ fpContextId: true }).extend({
  context: ForgeProjectContext,
  members: z.array(DTOForgeProjectMember),
});

export const DTOCreateForgeProject = ForgeProject.pick({
  instruction: true,
  name: true,
  meta: true,
  tags: true,
  accessMode: true,
  fpContextId: true,
  isArchived: true,
});

export const DTOUpdateForgeProject = DTOCreateForgeProject.partial().extend({
  id: z.string(),
  membersToRetain: z.string().array().min(1).optional(),
});

export const DTOForgeProjectGetResponse = z.object({ project: DTOForgeProject.nullable() });

export const DTOForgeProjectsListResponse = z.object({ projects: z.array(DTOForgeProject) });

export const DTOCreateForgeProjectResponse = z.object({
  project: DTOForgeProject,
});

export const DTOUpdateForgeProjectResponse = z.object({
  project: DTOForgeProject.nullable(),
});

export const DTOUGetForgeProjectResponse = z.object({
  project: DTOForgeProject,
});

export const DTORemoveForgeProjectResponse = z.object({ ok: z.literal(true) });

export type DTOForgeProject = z.infer<typeof DTOForgeProject>;
export type DTOForgeProjectGetResponse = z.infer<typeof DTOForgeProjectGetResponse>;
export type DTOForgeProjectsListResponse = z.infer<typeof DTOForgeProjectsListResponse>;
export type DTOCreateForgeProjectResponse = z.infer<typeof DTOCreateForgeProjectResponse>;
export type DTOUpdateForgeProjectResponse = z.infer<typeof DTOUpdateForgeProjectResponse>;
export type DTOUGetForgeProjectResponse = z.infer<typeof DTOUGetForgeProjectResponse>;
export type DTOCreateForgeProject = z.infer<typeof DTOCreateForgeProject>;
export type DTOUpdateForgeProject = z.infer<typeof DTOUpdateForgeProject>;
export type DTORemoveForgeProjectResponse = z.infer<typeof DTORemoveForgeProjectResponse>;
